module.exports = __webpack_public_path__ + "img/img11.4fa807c3.jpg";